<template>
  <div>
    <markdownEditor v-model="content" @imageAdded="catchImage" />

    <vue-markdown :source="decodeMarkdownToLinks(content)" />
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown"
import markdownHelpers from "@/utils/markdownEditorHelpers"
import markdownEditor from "@/components/questions/MarkdownReadingEditor"

export default {
  components: { markdownEditor, VueMarkdown },
  data() {
    return {
      content: "abcd",
      attachments: [],
    }
  },
  methods: {
    catchImage(eventObj) {
      this.content = eventObj.encodedString
      for (let i = 0; i < eventObj.attachments.length; i++) {
        this.attachments.push(eventObj.attachments[i])
      }
    },
    decodeMarkdownToLinks(content) {
      return markdownHelpers.decodeIDsToMarkdownLinks(content, this.attachments)
    },
  },
}
</script>
